import React from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import "./MainLayout.css";

const { Content } = Layout;

interface MainLayoutProps {
  title?: string;
  subtitle?: string;
  searchPlaceholder?: string;
  onSearch?: (value: string) => void;
  showSearch?: boolean;
  children?: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({
  title,
  subtitle,
  searchPlaceholder,
  onSearch,
  showSearch = true,
  children,
}) => {
  return (
    <Layout className="main-layout">
      <Sidebar />
      <Layout className="content-layout">
        <Header
          title={title}
          subtitle={subtitle}
          searchPlaceholder={searchPlaceholder}
          onSearch={onSearch}
          showSearch={showSearch}
        />
        <Content className="main-content">{children || <Outlet />}</Content>
      </Layout>
    </Layout>
  );
};
